// @core/api/endpoints/workflow/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.
import { CancelExecution } from './cancel_execution';
import { CancelPipelineRunAsRequest } from './cancel_pipeline_run_as_request';
import { CaptureTestCase } from './capture_test_case';
import { CreateAgentTool } from './create_agent_tool';
import { CreateCredential } from './create_credential';
import { CreateEnvironment } from './create_environment';
import { CreatePipeline } from './create_pipeline';
import { CreatePipelinePolicy } from './create_pipeline_policy';
import { CreatePromptTemplate } from './create_prompt_template';
import { CreateSchedule } from './create_schedule';
import { CreateTemplate } from './create_template';
import { CreateTestCase } from './create_test_case';
import { CreateTestSuite } from './create_test_suite';
import { DebugStep } from './debug_step';
import { DecidePipelineRunAsRequest } from './decide_pipeline_run_as_request';
import { DelegateDecision } from './delegate_decision';
import { DeleteAgentTool } from './delete_agent_tool';
import { DeleteCredential } from './delete_credential';
import { DeleteEnvironment } from './delete_environment';
import { DeleteNodeType } from './delete_node_type';
import { DeletePipeline } from './delete_pipeline';
import { DeletePipelinePolicy } from './delete_pipeline_policy';
import { DeletePromptTemplate } from './delete_prompt_template';
import { DeleteSchedule } from './delete_schedule';
import { DeleteTestCase } from './delete_test_case';
import { DiffPipelineVersions } from './diff_pipeline_versions';
import { DuplicatePipeline } from './duplicate_pipeline';
import { ExecutePipeline } from './execute_pipeline';
import { ExportPipelineYAML } from './export_pipeline_yaml';
import { GenerateTestCase } from './generate_test_case';
import { GetAgentTool } from './get_agent_tool';
import { GetCredential } from './get_credential';
import { GetEventDescriptor } from './get_event_descriptor';
import { GetExecution } from './get_execution';
import { GetExecutionLogs } from './get_execution_logs';
import { GetNodeType } from './get_node_type';
import { GetPendingDecision } from './get_pending_decision';
import { GetPipeline } from './get_pipeline';
import { GetPipelinePolicy } from './get_pipeline_policy';
import { GetPipelinePolicyByEntity } from './get_pipeline_policy_by_entity';
import { GetPipelineRunAsEligibility } from './get_pipeline_run_as_eligibility';
import { GetPipelineRunAsRequest } from './get_pipeline_run_as_request';
import { GetPipelineVersion } from './get_pipeline_version';
import { GetProductManifest } from './get_product_manifest';
import { GetPromptTemplate } from './get_prompt_template';
import { GetTemplate } from './get_template';
import { GetTestResult } from './get_test_result';
import { ImportPipelineYAML } from './import_pipeline_yaml';
import { InstallProductPipelines } from './install_product_pipelines';
import { InstallTemplate } from './install_template';
import { ListAgentTools } from './list_agent_tools';
import { ListCredentials } from './list_credentials';
import { ListEnvironments } from './list_environments';
import { ListEventDescriptors } from './list_event_descriptors';
import { ListExecutions } from './list_executions';
import { ListExecutionsByActor } from './list_executions_by_actor';
import { ListNodeTypes } from './list_node_types';
import { ListPendingDecisions } from './list_pending_decisions';
import { ListPipelinePolicies } from './list_pipeline_policies';
import { ListPipelineRunAsRequests } from './list_pipeline_run_as_requests';
import { ListPipelineVersions } from './list_pipeline_versions';
import { ListPipelines } from './list_pipelines';
import { ListPromptTemplates } from './list_prompt_templates';
import { ListRegisteredProducts } from './list_registered_products';
import { ListSchedules } from './list_schedules';
import { ListTemplates } from './list_templates';
import { ListTestCases } from './list_test_cases';
import { ListTestResults } from './list_test_results';
import { PauseExecution } from './pause_execution';
import { PausePipeline } from './pause_pipeline';
import { PauseSchedule } from './pause_schedule';
import { PublishPipeline } from './publish_pipeline';
import { RegisterNodeType } from './register_node_type';
import { RemoveBreakpoint } from './remove_breakpoint';
import { ResolvePipelineContext } from './resolve_pipeline_context';
import { ResumeExecution } from './resume_execution';
import { ResumePipeline } from './resume_pipeline';
import { ResumeSchedule } from './resume_schedule';
import { RetryExecution } from './retry_execution';
import { RevertToVersion } from './revert_to_version';
import { RevokePipelineRunAsAuthorization } from './revoke_pipeline_run_as_authorization';
import { RunTestCase } from './run_test_case';
import { RunTestSuite } from './run_test_suite';
import { SaveDraft } from './save_draft';
import { SetBreakpoint } from './set_breakpoint';
import { SetPipelineRunAs } from './set_pipeline_run_as';
import { StartDebugSession } from './start_debug_session';
import { StopDebugSession } from './stop_debug_session';
import { SubmitDecision } from './submit_decision';
import { SyncProductManifest } from './sync_product_manifest';
import { SyncProductPipelines } from './sync_product_pipelines';
import { TestCredential } from './test_credential';
import { TestPromptTemplate } from './test_prompt_template';
import { TriggerWebhook } from './trigger_webhook';
import { UpdateAgentTool } from './update_agent_tool';
import { UpdateCredential } from './update_credential';
import { UpdateEnvironment } from './update_environment';
import { UpdateNodeType } from './update_node_type';
import { UpdatePipeline } from './update_pipeline';
import { UpdatePipelinePolicy } from './update_pipeline_policy';
import { UpdatePromptTemplate } from './update_prompt_template';
import { UpdateSchedule } from './update_schedule';
import { UpdateTestCase } from './update_test_case';
import { ValidatePipelineYAML } from './validate_pipeline_yaml';

// Re-export individual endpoints
export {
  CancelExecution,
  CancelPipelineRunAsRequest,
  CaptureTestCase,
  CreateAgentTool,
  CreateCredential,
  CreateEnvironment,
  CreatePipeline,
  CreatePipelinePolicy,
  CreatePromptTemplate,
  CreateSchedule,
  CreateTemplate,
  CreateTestCase,
  CreateTestSuite,
  DebugStep,
  DecidePipelineRunAsRequest,
  DelegateDecision,
  DeleteAgentTool,
  DeleteCredential,
  DeleteEnvironment,
  DeleteNodeType,
  DeletePipeline,
  DeletePipelinePolicy,
  DeletePromptTemplate,
  DeleteSchedule,
  DeleteTestCase,
  DiffPipelineVersions,
  DuplicatePipeline,
  ExecutePipeline,
  ExportPipelineYAML,
  GenerateTestCase,
  GetAgentTool,
  GetCredential,
  GetEventDescriptor,
  GetExecution,
  GetExecutionLogs,
  GetNodeType,
  GetPendingDecision,
  GetPipeline,
  GetPipelinePolicy,
  GetPipelinePolicyByEntity,
  GetPipelineRunAsEligibility,
  GetPipelineRunAsRequest,
  GetPipelineVersion,
  GetProductManifest,
  GetPromptTemplate,
  GetTemplate,
  GetTestResult,
  ImportPipelineYAML,
  InstallProductPipelines,
  InstallTemplate,
  ListAgentTools,
  ListCredentials,
  ListEnvironments,
  ListEventDescriptors,
  ListExecutions,
  ListExecutionsByActor,
  ListNodeTypes,
  ListPendingDecisions,
  ListPipelinePolicies,
  ListPipelineRunAsRequests,
  ListPipelineVersions,
  ListPipelines,
  ListPromptTemplates,
  ListRegisteredProducts,
  ListSchedules,
  ListTemplates,
  ListTestCases,
  ListTestResults,
  PauseExecution,
  PausePipeline,
  PauseSchedule,
  PublishPipeline,
  RegisterNodeType,
  RemoveBreakpoint,
  ResolvePipelineContext,
  ResumeExecution,
  ResumePipeline,
  ResumeSchedule,
  RetryExecution,
  RevertToVersion,
  RevokePipelineRunAsAuthorization,
  RunTestCase,
  RunTestSuite,
  SaveDraft,
  SetBreakpoint,
  SetPipelineRunAs,
  StartDebugSession,
  StopDebugSession,
  SubmitDecision,
  SyncProductManifest,
  SyncProductPipelines,
  TestCredential,
  TestPromptTemplate,
  TriggerWebhook,
  UpdateAgentTool,
  UpdateCredential,
  UpdateEnvironment,
  UpdateNodeType,
  UpdatePipeline,
  UpdatePipelinePolicy,
  UpdatePromptTemplate,
  UpdateSchedule,
  UpdateTestCase,
  ValidatePipelineYAML,
};

// Namespace export for convenient usage
export const workflowApi = {
  CancelExecution,
  CancelPipelineRunAsRequest,
  CaptureTestCase,
  CreateAgentTool,
  CreateCredential,
  CreateEnvironment,
  CreatePipeline,
  CreatePipelinePolicy,
  CreatePromptTemplate,
  CreateSchedule,
  CreateTemplate,
  CreateTestCase,
  CreateTestSuite,
  DebugStep,
  DecidePipelineRunAsRequest,
  DelegateDecision,
  DeleteAgentTool,
  DeleteCredential,
  DeleteEnvironment,
  DeleteNodeType,
  DeletePipeline,
  DeletePipelinePolicy,
  DeletePromptTemplate,
  DeleteSchedule,
  DeleteTestCase,
  DiffPipelineVersions,
  DuplicatePipeline,
  ExecutePipeline,
  ExportPipelineYAML,
  GenerateTestCase,
  GetAgentTool,
  GetCredential,
  GetEventDescriptor,
  GetExecution,
  GetExecutionLogs,
  GetNodeType,
  GetPendingDecision,
  GetPipeline,
  GetPipelinePolicy,
  GetPipelinePolicyByEntity,
  GetPipelineRunAsEligibility,
  GetPipelineRunAsRequest,
  GetPipelineVersion,
  GetProductManifest,
  GetPromptTemplate,
  GetTemplate,
  GetTestResult,
  ImportPipelineYAML,
  InstallProductPipelines,
  InstallTemplate,
  ListAgentTools,
  ListCredentials,
  ListEnvironments,
  ListEventDescriptors,
  ListExecutions,
  ListExecutionsByActor,
  ListNodeTypes,
  ListPendingDecisions,
  ListPipelinePolicies,
  ListPipelineRunAsRequests,
  ListPipelineVersions,
  ListPipelines,
  ListPromptTemplates,
  ListRegisteredProducts,
  ListSchedules,
  ListTemplates,
  ListTestCases,
  ListTestResults,
  PauseExecution,
  PausePipeline,
  PauseSchedule,
  PublishPipeline,
  RegisterNodeType,
  RemoveBreakpoint,
  ResolvePipelineContext,
  ResumeExecution,
  ResumePipeline,
  ResumeSchedule,
  RetryExecution,
  RevertToVersion,
  RevokePipelineRunAsAuthorization,
  RunTestCase,
  RunTestSuite,
  SaveDraft,
  SetBreakpoint,
  SetPipelineRunAs,
  StartDebugSession,
  StopDebugSession,
  SubmitDecision,
  SyncProductManifest,
  SyncProductPipelines,
  TestCredential,
  TestPromptTemplate,
  TriggerWebhook,
  UpdateAgentTool,
  UpdateCredential,
  UpdateEnvironment,
  UpdateNodeType,
  UpdatePipeline,
  UpdatePipelinePolicy,
  UpdatePromptTemplate,
  UpdateSchedule,
  UpdateTestCase,
  ValidatePipelineYAML,
};
